import { AttributeDefinition } from "@wingspanhq/wingspan-api-sdk";

export interface FieldCounts {
  required: number;
  optional: number;
}

export function selectorFieldCounts(
  attributeDefinitions: AttributeDefinition[]
): FieldCounts {
  return attributeDefinitions.reduce(
    (acc, field) => {
      if (field.isRequired) {
        acc.required += 1;
      } else {
        acc.optional += 1;
      }
      return acc;
    },
    { required: 0, optional: 0 }
  );
}
